module.exports = __webpack_public_path__ + "img/Search.fba94f32.svg";